"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcealedFieldViewer = void 0;
var React = require("react");
var _Core_1 = require("../../_Core");
var Keyboard_1 = require("../../_Core/Keyboard");
var Spinner_1 = require("../../Animations/Spinner");
var Icon_1 = require("../../Icons/Icon");
var Localization_1 = require("../../Localization");
var Theme_1 = require("../../Theme");
var ConcealedFieldViewer_styles_1 = require("./ConcealedFieldViewer.styles");
// default size for Icon & Spinner
var IconSize = 24;
var SpinnerSize = 12;
var BorderSize = 3;
var BulletsCount = 10;
exports.ConcealedFieldViewer = React.forwardRef(function (_a, ref) {
    var OnRetrieve = _a.OnRetrieve;
    var _b = React.useState(false), isHovered = _b[0], setHovered = _b[1];
    var _c = React.useState(true), isConcealed = _c[0], setConcealed = _c[1];
    var _d = React.useState(false), isLoading = _d[0], setLoading = _d[1];
    var _e = React.useState(""), value = _e[0], setValue = _e[1];
    var bullets = React.createElement(React.Fragment, null, Array(BulletsCount).fill(0).map(function () { return "•"; }));
    var caption = isConcealed ? bullets : value;
    React.useImperativeHandle(ref, function () { return ({
        IsConcealed: function () {
            return isConcealed;
        },
        UpdateValue: function (valueToUpdate) {
            setValue(valueToUpdate);
        },
    }); });
    var handleOnHide = function () {
        if (isConcealed) {
            return;
        }
        setValue("");
        setConcealed(true);
    };
    var handleOnClick = function () {
        if (isConcealed) {
            setLoading(true);
            OnRetrieve().then(function (result) {
                setValue(result);
                setLoading(false);
                setConcealed(false);
            }).catch(function (error) {
                throw error;
            }).finally(function () { return setLoading(false); });
        }
        else {
            handleOnHide();
        }
    };
    var handleOnKeyUp = function (e) {
        if (Keyboard_1.IsEnter(e) || Keyboard_1.IsSpace(e)) {
            handleOnClick();
        }
        else if (Keyboard_1.IsEscape(e)) {
            handleOnHide();
        }
    };
    return (React.createElement(ConcealedFieldViewer_styles_1.Container, null,
        React.createElement(ConcealedFieldViewer_styles_1.ConcealedFieldViewerWrapper, { tabIndex: 0, onClick: handleOnClick, onKeyUp: handleOnKeyUp, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); }, title: isConcealed ? Localization_1.strings.ConcealedFieldViewer_Title_View : Localization_1.strings.ConcealedFieldViewer_Title_Conceal, role: "button" },
            React.createElement(ConcealedFieldViewer_styles_1.IconWrapper, { Hovered: isHovered }, isLoading ?
                React.createElement(ConcealedFieldViewer_styles_1.SpinnerWrapper, { IconSize: IconSize },
                    React.createElement(Spinner_1.Spinner, { Size: SpinnerSize + "px", Color: Theme_1.Color.Blue.B60, BorderSize: BorderSize + "px" })) :
                React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons[isConcealed ? "View" : "Hide"], Height: IconSize + "px", Width: IconSize + "px" })),
            React.createElement(ConcealedFieldViewer_styles_1.Caption, null, caption))));
});
